import type { IGetAllLeagues } from "../components/header/types/header";

type MaybeLeague = IGetAllLeagues | null | undefined;

export const isLeagueAdmin = (league: MaybeLeague): boolean =>
  (league?.roleName ?? "").toUpperCase().includes("LEAGUE_ADMIN");

export const canCreateTournamentInLeague = (league: MaybeLeague): boolean =>
  isLeagueAdmin(league) || Boolean(league?.canAddTournamentToLeague);

export const canScheduleMatchesInLeague = (league: MaybeLeague): boolean =>
  canCreateTournamentInLeague(league);

export const canAddGroundInLeague = (league: MaybeLeague): boolean =>
  isLeagueAdmin(league) || Boolean(league?.canEditLeague) || Boolean(league?.canCreateDivisions);

export const canManageLeagueDocuments = (league: MaybeLeague): boolean =>
  isLeagueAdmin(league) || Boolean(league?.canEditLeague);

export const canManageLeagueGalleryByRole = (league: MaybeLeague): boolean =>
  isLeagueAdmin(league) || Boolean(league?.canEditLeague);

export const canManageDivisionsInLeague = (league: MaybeLeague): boolean =>
  isLeagueAdmin(league) || Boolean(league?.canEditLeague) || Boolean(league?.canCreateDivisions);
